<!-- <app-tools-page-tabs></app-tools-page-tabs> -->

<section class="mainTopBanner toolsTopBanner section-pd sm-pd-20">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="topBannerWrapper align-items-center">
                    <div class="top-banner-left text-center">
                        <h1 class="singleTag">免費線上文章改寫工具</h1>
                        <p class="mb-0">用 Trinka 的文章改寫工具，讓你的寫作更清楚、表達更有力。</p>
                        <p>輕鬆改寫句子，同時保留原意，讓內容更通順自然。</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="card paraphraser-card">
                    <div class="card-header">
                        <h2 class="d-none d-md-block">改寫您的文字</h2>
                        <div class="degreeChange">
                            <ul>
                                <li>
                                    <div class="slidecontainer">
                                        <span>改寫幅度</span>
                                        <div class="" style="display: flex;align-items: center;">
                                            <i class="lowTextSection" style="left: -26px;right: auto;">低</i>
                                            <input id="myRange" class="slider" type="range" min="1" max="2" step="0.5" [value]="paraphraseTemperature" [(ngModel)]="paraphraseTemperature" [ngModelOptions]={standalone:true} (change)="updateParaphraseTemperature($event)" aria-label="degree of change">
                                            <i class="highTextSection" style="right: -26px;left: auto;">高</i>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="toggleDiffOption">
                                        <i>顯示修改紀錄</i>
                                        <label class="switch" aria-label="show revision">
                                          <input id="toggleDiffOptionCheckbox" type="checkbox" [(ngModel)]="toggleDiffOptionModel" [ngModelOptions]={standalone:true} [checked]="toggleDiffOptionModel" (change)="onToggleDiffOption()">
                                          <span class="slider round"></span>
                                        </label>
                                    </div>
                                </li>
                                <li>
                                    <div class="feedback" (click)="openFeedbackModal()">
                                        <svg class="feedbackIcons" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9.99996 19.0082C9.42496 19.0082 8.88329 18.7165 8.49996 18.2082L7.24996 16.5415C7.22496 16.5082 7.12496 16.4665 7.08329 16.4582H6.66663C3.19163 16.4582 1.04163 15.5165 1.04163 10.8332V6.6665C1.04163 2.98317 2.98329 1.0415 6.66663 1.0415H13.3333C17.0166 1.0415 18.9583 2.98317 18.9583 6.6665V10.8332C18.9583 14.5165 17.0166 16.4582 13.3333 16.4582H12.9166C12.85 16.4582 12.7916 16.4915 12.75 16.5415L11.5 18.2082C11.1166 18.7165 10.575 19.0082 9.99996 19.0082ZM6.66663 2.2915C3.68329 2.2915 2.29163 3.68317 2.29163 6.6665V10.8332C2.29163 14.5998 3.58329 15.2082 6.66663 15.2082H7.08329C7.50829 15.2082 7.99163 15.4498 8.24996 15.7915L9.49996 17.4582C9.79163 17.8415 10.2083 17.8415 10.5 17.4582L11.75 15.7915C12.025 15.4248 12.4583 15.2082 12.9166 15.2082H13.3333C16.3166 15.2082 17.7083 13.8165 17.7083 10.8332V6.6665C17.7083 3.68317 16.3166 2.2915 13.3333 2.2915H6.66663Z" fill="#7A28A0"/>
                                            <path d="M14.1667 7.2915H5.83337C5.49171 7.2915 5.20837 7.00817 5.20837 6.6665C5.20837 6.32484 5.49171 6.0415 5.83337 6.0415H14.1667C14.5084 6.0415 14.7917 6.32484 14.7917 6.6665C14.7917 7.00817 14.5084 7.2915 14.1667 7.2915Z" fill="#7A28A0"/>
                                            <path d="M10.8334 11.4585H5.83337C5.49171 11.4585 5.20837 11.1752 5.20837 10.8335C5.20837 10.4918 5.49171 10.2085 5.83337 10.2085H10.8334C11.175 10.2085 11.4584 10.4918 11.4584 10.8335C11.4584 11.1752 11.175 11.4585 10.8334 11.4585Z" fill="#7A28A0"/>
                                        </svg>
                                        <svg class="feedbackIconsHover" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M14.1667 1.66669H5.83334C3.53334 1.66669 1.66667 3.52502 1.66667 5.81669V10.8V11.6334C1.66667 13.925 3.53334 15.7834 5.83334 15.7834H7.08334C7.30834 15.7834 7.60834 15.9334 7.75001 16.1167L9.00001 17.775C9.55001 18.5084 10.45 18.5084 11 17.775L12.25 16.1167C12.4083 15.9084 12.6583 15.7834 12.9167 15.7834H14.1667C16.4667 15.7834 18.3333 13.925 18.3333 11.6334V5.81669C18.3333 3.52502 16.4667 1.66669 14.1667 1.66669ZM10.8333 11.4584H5.83334C5.49167 11.4584 5.20834 11.175 5.20834 10.8334C5.20834 10.4917 5.49167 10.2084 5.83334 10.2084H10.8333C11.175 10.2084 11.4583 10.4917 11.4583 10.8334C11.4583 11.175 11.175 11.4584 10.8333 11.4584ZM14.1667 7.29169H5.83334C5.49167 7.29169 5.20834 7.00835 5.20834 6.66669C5.20834 6.32502 5.49167 6.04169 5.83334 6.04169H14.1667C14.5083 6.04169 14.7917 6.32502 14.7917 6.66669C14.7917 7.00835 14.5083 7.29169 14.1667 7.29169Z" fill="#7A28A0"/>
                                        </svg>
                                        <b>Feedback</b>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="card-body" style="min-height: 360px;">
                        <div class="left-side">
                            <div class="form-group" style="height: calc(100% - 88px);">

                                <div class="editor-wrapper" style="position: relative; height: 100%; padding: 24px 40px 0px 24px;">
                                  <span *ngIf="wordCounts.input" class="pp-icon-times" (click)="clearEditors();" style="position: absolute; right: 10px; top: 15px; cursor: pointer;"></span>
                                  <div #inputEditor contenteditable="true" spellcheck="false" id="inputEditor" class="editor" style="height: 100%; outline: 0px solid transparent; overflow: hidden; padding-bottom: 30px;" (input)="onInputEditorChange($event)" placeholder="Type or paste your text to paraphrase... "></div>
                                </div>

                            </div>

                            <div class="card-footer">
                                <div  class="counter">
                                    <span class="count" [ngClass]="wordCounts.input >= 500 ? 'red': ''">{{ wordCounts.input }}/500 words</span>
                                </div>
                                <div class="button-wrap">
                                    <button type="button" (click)="paraphrase()" [disabled]="loader">
                                        <span [style.display]="loader ? 'none' : 'block'">改寫</span>
                                        <div class="loadingContainer" [style.display]="loader ? 'block' : 'none'">
                                            <div class="ball1"></div>
                                            <div class="ball2"></div>
                                            <div class="ball3"></div>
                                            <div class="ball4"></div>
                                        </div>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="right-side"> <!-- blur -->
                            <div class="form-group" style="height: calc(100% - 88px);">

                                <div class="editor-wrapper" style="height: 100%; padding: 24px 40px 0px 24px; position: relative;">
                                  <div #popoverOverlay id="popoverOverlay" style="top: 24px; left: 24px; right: 24px; bottom: 0;">
                                    <div style="position: relative; width: 100%; height: 100%;">
                                      <div #popover id="popover">
                                        <div class="popover-content">
                                          <div>
                                            <span class="likeDislikeSection" (click)="popoverOptionSelected($event, 'like', currentSelectedSentenceState.alternatives.original_sentence, currentSelectedSentenceState.sentenceTag.textContent)">
                                                <span class="pp-icon-like"></span>
                                                <span class="pp-icon-like pp-icon-like-hover"></span>
                                            </span>
                                          </div>
                                          <div>
                                            <span class="likeDislikeSection" (click)="popoverOptionSelected($event, 'dislike', currentSelectedSentenceState.alternatives.original_sentence, currentSelectedSentenceState.sentenceTag.textContent)">
                                                <span class="pp-icon-dislike"></span>
                                                <span class="pp-icon-dislike pp-icon-dislike-hover"></span>
                                            </span>
                                          </div>
                                          <div>
                                            <span class="textCopiedSection" (click)="popoverOptionSelected($event, 'copy', currentSelectedSentenceState.alternatives.original_sentence, currentSelectedSentenceState.sentenceTag.textContent)">
                                                <span class="pp-icon-copy"></span>
                                                <span class="pp-icon-copy pp-icon-copy-hover"></span>
                                            </span>
                                          </div>
                                        </div>
                                      </div>

                                      <div #alternativesPopover id="alternativesPopover">
                                        <div class="alternativesPopover-content">
                                          <div class="heading">
                                            <span>Alternatives</span>
                                            <span class="closePopoverBtn" (click)="closePopover()" style="cursor: pointer;">
                                                <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g clip-path="url(#clip0_330_14955)">
                                                    <path d="M17.4082 6.66472C17.7614 6.31148 17.7614 5.73877 17.4082 5.38553C17.0549 5.0323 16.4822 5.0323 16.129 5.38553L11.3414 10.1731L6.55388 5.38553C6.20064 5.0323 5.62793 5.0323 5.27469 5.38553C4.92146 5.73877 4.92146 6.31148 5.27469 6.66472L10.0622 11.4523L5.27469 16.2398C4.92146 16.593 4.92146 17.1658 5.27469 17.519C5.62793 17.8722 6.20064 17.8722 6.55388 17.519L11.3414 12.7315L16.129 17.519C16.4822 17.8722 17.0549 17.8722 17.4082 17.519C17.7614 17.1658 17.7614 16.593 17.4082 16.2398L12.6206 11.4523L17.4082 6.66472Z" fill="#414E62"/>
                                                    </g>
                                                    <defs>
                                                    <clipPath id="clip0_330_14955">
                                                    <rect width="21.7085" height="21.7085" fill="white" transform="translate(0.487305 0.5979)"/>
                                                    </clipPath>
                                                    </defs>
                                                </svg>
                                            </span>
                                          </div>
                                          <div class="body">
                                            <ul *ngIf="currentSelectedSentenceState.alternatives">
                                              <ng-container *ngFor="let alternative of currentSelectedSentenceState.alternatives.output_sentence; let i = index;">
                                                <li *ngIf="currentSelectedSentenceState.index != i" (click)="switchToTheAlternative(alternative, i)">
                                                  <sentence [innerHTML]="alternative.suggestion_diff" *ngIf="toggleDiffOptionModel; else nonDiff"></sentence>
                                                  <ng-template #nonDiff>
                                                    <sentence>{{alternative.suggestion}}</sentence>
                                                  </ng-template>
                                                  <span class="likeAndDislikeButtons">
                                                    <span class="likeDislikeSection" (click)="popoverOptionSelected($event, 'like', currentSelectedSentenceState.alternatives.original_sentence, alternative.suggestion)">
                                                        <span class="pp-icon-like"></span>
                                                        <span class="pp-icon-like pp-icon-like-hover"></span>
                                                    </span>
                                                    <span class="likeDislikeSection" (click)="popoverOptionSelected($event, 'dislike', currentSelectedSentenceState.alternatives.original_sentence, alternative.suggestion)">
                                                        <span class="pp-icon-dislike"></span>
                                                        <span class="pp-icon-dislike pp-icon-dislike-hover"></span>
                                                    </span>
                                                  </span>
                                                </li>
                                              </ng-container>
                                            </ul>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div #outputEditor contenteditable="false" spellcheck="false" id="outputEditor" class="editor" style="outline: 0px solid transparent; overflow: hidden; padding-bottom: 30px;"></div>

                                  <div class="limit-exhausted-banner" *ngIf="wordCounts.output > 1 && isLimitExhausted && !loader">
                                    <h3>
                                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M18.4645 14.3459L13.248 4.95619C12.5471 3.69282 11.5771 3 10.5094 3C9.44161 3 8.47166 3.69282 7.77069 4.95619L2.55419 14.3459C1.89397 15.5441 1.82062 16.6933 2.35042 17.5981C2.88022 18.5028 3.92352 19 5.29285 19H15.7259C17.0952 19 18.1385 18.5028 18.6683 17.5981C19.1981 16.6933 19.1247 15.5359 18.4645 14.3459ZM9.89805 8.70555C9.89805 8.37137 10.1752 8.09424 10.5094 8.09424C10.8435 8.09424 11.1207 8.37137 11.1207 8.70555V12.7809C11.1207 13.1151 10.8435 13.3923 10.5094 13.3923C10.1752 13.3923 9.89805 13.1151 9.89805 12.7809V8.70555ZM11.0881 15.8049C11.0473 15.8375 11.0066 15.8701 10.9658 15.9027C10.9169 15.9353 10.868 15.9598 10.8191 15.9761C10.7702 16.0005 10.7213 16.0168 10.6642 16.025C10.6153 16.0331 10.5583 16.0413 10.5094 16.0413C10.4605 16.0413 10.4034 16.0331 10.3463 16.025C10.2974 16.0168 10.2485 16.0005 10.1996 15.9761C10.1507 15.9598 10.1018 15.9353 10.0529 15.9027C10.0122 15.8701 9.97141 15.8375 9.93065 15.8049C9.78394 15.65 9.69428 15.4381 9.69428 15.2262C9.69428 15.0143 9.78394 14.8023 9.93065 14.6475C9.97141 14.6149 10.0122 14.5823 10.0529 14.5497C10.1018 14.5171 10.1507 14.4926 10.1996 14.4763C10.2485 14.4519 10.2974 14.4356 10.3463 14.4274C10.4523 14.403 10.5664 14.403 10.6642 14.4274C10.7213 14.4356 10.7702 14.4519 10.8191 14.4763C10.868 14.4926 10.9169 14.5171 10.9658 14.5497C11.0066 14.5823 11.0473 14.6149 11.0881 14.6475C11.2348 14.8023 11.3244 15.0143 11.3244 15.2262C11.3244 15.4381 11.2348 15.65 11.0881 15.8049Z" fill="#FFBD4A"/>
                                        </svg>
                                        Word limit reached
                                    </h3>
                                    <p>You can paraphrase <strong>500 words</strong> at a time. For longer paragraphs, split the paragraph into smaller ones and then paraphrase. </p>
                                  </div>

                                </div>
                            </div>
                            <div class="card-footer">
                                <div  class="counter">
                                    <!-- <span class="count">{{ wordCounts.output }} words</span> -->
                                </div>
                                <div class="copy-text">
                                    <span [ngClass]="toggleDiffOptionModel ? 'disableCopyOption': ''" >
                                        <span class="disabledTooltip">Turn revisions off to copy</span>
                                        <span class="copyTooltip">Copy text</span>
                                        <img src="assets/images/tools/icons/copy.svg" alt="copy" (click)="copyOutputEditorContent()" />
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <ul class="wordcrumbs">
                    <li>修改的文字</li>
                    <li>改寫後的文字</li>
                </ul>
            </div>
        </div>
    </div>
    <span class="shape shape-1"></span>
    <span class="shape shape-2"></span>
</section>

<section class="trinka-banner section-pd-sm">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-11 col-lg-9">
                <div class="trinka-title text-center">
                    <h3 class="text-white">Trinka 提供一整套工具，幫助你提升寫作體驗——而且最棒的是，全部免費！</h3>
                </div>
                <div class="btn-group justify-content-center">
                    <a href="https://cloud.trinka.ai/signup?_rg=TW" class="white-btn" target="_blank">馬上體驗</a>
                </div>
            </div>
        </div>  
    </div>
</section>

<section class="section-pd">
    <div class="list-wrapper-style-2">
        <div class="trinka_container container">
            <div class="row justify-content-center">
                <div class="col-md-10 col-lg-8">
                    <div class="trinka-title text-center">
                        <h2>為什麼選擇 Trinka 線上改寫工具？</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    </div>
                </div>
            </div>
            <div class="row flex-row-reverse align-items-center">
                <div class="col-lg-6">
                    <div class="list-wrapper-content-2" style="padding: 0;">
                        <p>Trinka 的改寫工具專為提升內容流暢度而設，同時確保你在任何場合都能使用合適的詞彙、語氣和風格。</p>
                        <p>你可以為每句話選擇多種改寫選項，還能調整改寫的變化程度，讓改寫結果更貼合你的寫作需求。</p>
                        <p>Trinka 改寫工具免費且操作簡單，只要輕輕一按，就能幫你重新表達文字，而且提供多種選項，讓你自由調整，打造理想的改寫內容。</p>
                        <p><b>Trinka 改寫工具——讓內容重寫輕鬆無縫的最佳選擇！</b></p>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="list-wrapper-image">
                        <img src="assets/images/tools/paraphrase.svg" width="207" height="150" alt="paraphrasing tool" class="img-fluid" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="list-wrapper-style-2 section-pd pb-0">
        <div class="trinka_container container">
            <div class="row justify-content-center align-items-center">
                <div class="col-md-12 col-lg-10">
                    <div class="trinka-title text-center">
                        <h2>Trinka 獨特功能：讓句子表達更出色！</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <div class="list-wrapper-content-2 pr-80" style="padding: 0;">
                        <ul class="list-box">
                            <li>Trinka 改寫工具——讓內容重寫輕鬆無縫的最佳選擇！</li>
                            <li>根據需求調整改寫幅度，輕鬆打造完美句子。</li>
                            <li>告別文法錯誤，Trinka 自動校正，讓你的文章更流暢、無瑕疵。</li>
                            <li>輕鬆一鍵快速改寫，立即獲得全新句子。</li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="list-wrapper-image">
                        <img src="assets/images/tools/academic-parapharsing.svg" width="191" height="150" alt="paraphrasing tool" class="img-fluid" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd bg-light-purple list-wrapper-style-2">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-11">
                <div class="trinka-title mb-0 text-center">
                    <h2>線上改寫工具的主要優點</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>
                        探索 Trinka 線上改寫工具的完整功能。
                    </p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <img src="assets/images/Efficiency.png" width="50" height="50" alt="Paraphrase Efficiency" style="min-width: 50px;" />
                    <h3>高效改寫</h3>
                    <p>Trinka 幫助你節省改寫內容的時間和精力，讓你能專注於工作本身，而不是文字表達。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <img src="assets/images/Accuracy.png" width="40" height="50" alt="Improved Clarity" style="max-width: auto;" />
                    <h3>
                        清晰度提升
                    </h3>
                    <p>Trinka 確保改寫後的內容保留原意和完整性，避免產生誤解。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <img src="assets/images/Vocabulary.png" width="40" height="50" alt="Remove Grammar Errors" style="max-width: auto;" />
                    <h3>消除文法錯誤</h3>
                    <p>Trinka 即時幫你消除文法錯誤，確保書寫準確無誤。</p>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="trinka-banner section-pd-sm">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-8">
                <div class="trinka-title text-center">
                    <h3 class="text-white">用 Trinka 全方位提升你的寫作品質</h3>
                </div>
                <div class="btn-group justify-content-center">
                    <a href="https://cloud.trinka.ai/signup?_rg=TW" class="white-btn" target="_blank">立即試用！</a>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="faqQuestionAnwser section-pd" #target>
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="trinka-title text-center">
                    <h2>Trinka 文章改寫工具常見問答</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="faqQuestionsList">
            <div class="accordion" id="faq">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionGCOne">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionGCOneContent" aria-expanded="true" aria-controls="QuestionGCOneContent">
                                        什麼是 Trinka 改寫工具？
                                    </a>
                                </div>

                                <div id="QuestionGCOneContent" class="collapse" aria-labelledby="QuestionGCOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka 改寫工具是一款免費的線上改寫工具，運用先進的自然語言處理技術，能在保留原文意思的同時，產出高品質的改寫內容</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionGCTwoContent" aria-expanded="true" aria-controls="QuestionGCTwoContent">
                                        首次使用 Trinka 改寫工具
                                    </a>
                                </div>

                                <div id="QuestionGCTwoContent" class="collapse" aria-labelledby="QuestionGCTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>請參考以下簡單的使用步驟：</p>
                                        <ul>
                                            <li>進入 Trinka 文章改寫工具網站</li>
                                            <li><b>輸入內容：</b>將你想改寫的文字複製並貼到指定的輸入框中</li>
                                            <li><b>開始改寫：</b>點擊「改寫」按鈕，工具將自動生成改寫版本</li>
                                            <li><b>檢查結果：</b>閱讀改寫後的內容，確認是否符合你的需求</li>
                                            <li><b>調整內容（如有需要）：</b>如果需要調整內容，可以手動修改改寫文字，使其更符合你的寫作風格</li>
                                            <li><b>完成文章改寫：</b>若覺得滿意改寫內容，就可以直接用在你的文章或其他需要的地方。</li>
                                        </ul>
                                        <p>照著這些步驟走，輕鬆完成改寫。按照這些步驟，你就能輕鬆又有效地使用 Trinka 的改寫工具來改寫你的內容。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionGCThreeContent" aria-expanded="true" aria-controls="QuestionGCThreeContent">
                                        Trinka 文章改寫工具如何運作？
                                    </a>
                                </div>

                                <div id="QuestionGCThreeContent" class="collapse" aria-labelledby="QuestionGCThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka 文章改寫工具運用先進的演算法，分析並重新組織文字，為用戶提供多種改寫版本，同時保持語意連貫和易讀性。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionGCFourContent" aria-expanded="true" aria-controls="QuestionGCFourContent">
                                        Trinka Paraphraser 可以線上使用還是需要下載至裝置？
                                    </a>
                                </div>

                                <div id="QuestionGCFourContent" class="collapse" aria-labelledby="QuestionGCFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka 改寫工具是線上使用的，不需安裝軟體，讓你隨時輕鬆使用。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCFive">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionGCFiveContent" aria-expanded="true" aria-controls="QuestionGCFiveContent">
                                        Trinka 改寫工具相比於像 QuillBot 改寫工具，有哪些獨特之處？
                                    </a>
                                </div>

                                <div id="QuestionGCFiveContent" class="collapse" aria-labelledby="QuestionGCFive" data-parent="#faq">
                                    <div class="card-body">
                                        <p>
                                            Trinka 改寫工具具備即時改寫功能，提供改寫幅度選擇、多重改寫版本，並透過句子重組自動修正文法錯誤，與市面上其他改寫工具相比更勝一籌。
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCSix">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionGCSixContent" aria-expanded="true" aria-controls="QuestionGCSixContent">
                                        Trinka 文章改寫工具的適用對象
                                    </a>
                                </div>

                                <div id="QuestionGCSixContent" class="collapse" aria-labelledby="QuestionGCSix" data-parent="#faq">
                                    <div class="card-body">
                                        <p>
                                            Trinka 改寫工具適用於廣泛的使用者群體，包括科學與技術等各領域的學者、內容撰稿人、部落客、學生、研究人員，以及需要產出多樣化內容的專業人士。
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCSeven">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionGCSevenContent" aria-expanded="true" aria-controls="QuestionGCSevenContent">
                                        使用 Trinka 改寫工具進行改寫時，有字數限制嗎？
                                    </a>
                                </div>

                                <div id="QuestionGCSevenContent" class="collapse" aria-labelledby="QuestionGCSeven" data-parent="#faq">
                                    <div class="card-body">
                                        <p>
                                            目前 Trinka 文章改寫工具每次可改寫上限為 500 字，但不限使用次數，讓你隨時自由改寫。不同於其他常設字數限制的線上改寫工具，Trinka 提供無限次使用，更加彈性
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCEight">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionGCEightContent" aria-expanded="true" aria-controls="QuestionGCEightContent">
                                        Trinka 改寫工具適合學術寫作者使用嗎？
                                    </a>
                                </div>

                                <div id="QuestionGCEightContent" class="collapse" aria-labelledby="QuestionGCEight" data-parent="#faq">
                                    <div class="card-body">
                                        <p>
                                            是的，Trinka 改寫工具專為學術寫作者打造，能有效協助改寫研究論文與文章內容，在保留原意的同時，產出具原創性與多樣化的表達方式。
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCNine">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionGCNineContent" aria-expanded="true" aria-controls="QuestionGCNineContent">
                                        部落客可以使用 Trinka 改寫工具來提升他們的內容品質嗎？
                                    </a>
                                </div>

                                <div id="QuestionGCNineContent" class="collapse" aria-labelledby="QuestionGCNine" data-parent="#faq">
                                    <div class="card-body">
                                        <p>當然可以，部落客可透過 Trinka 線上改寫工具重寫文章、探索不同表達方式，並提升內容品質。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCTen">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionGCTenContent" aria-expanded="true" aria-controls="QuestionGCTenContent">
                                        Trinka 文章改寫工具怎麼解決改寫很花時間的問題？
                                    </a>
                                </div>

                                <div id="QuestionGCTenContent" class="collapse" aria-labelledby="QuestionGCTen" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka 的即時改寫功能可以在你打字的同時自動產生不同版本，大大節省整理語句的時間。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCeleven">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionGCelevenContent" aria-expanded="true" aria-controls="QuestionGCelevenContent">
                                        Trinka 文章改寫工具如何幫你提高寫作效率？
                                    </a>
                                </div>

                                <div id="QuestionGCelevenContent" class="collapse" aria-labelledby="QuestionGCeleven" data-parent="#faq">
                                    <div class="card-body">
                                        <p>
                                            Trinka 很適合寫作卡關或詞彙不夠多的人，它能幫你找到最貼切的詞，讓你更清楚地表達想法，寫起來順手又有效率。
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCTwelve">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionGCTwelveContent" aria-expanded="true" aria-controls="QuestionGCTwelveContent">
                                        使用者可以自己調整 Trinka 文章改寫工具改寫的程度嗎？
                                    </a>
                                </div>

                                <div id="QuestionGCTwelveContent" class="collapse" aria-labelledby="QuestionGCTwelve" data-parent="#faq">
                                    <div class="card-body">
                                        <p>是的，使用者可以依照自己的需求，調整改寫的幅度，讓內容變化更符合期待。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionGCThirteen">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionGCThirteenContent" aria-expanded="true" aria-controls="QuestionGCThirteenContent">
                                        Trinka 改寫工具怎麼幫你修正文法錯誤？
                                    </a>
                                </div>

                                <div id="QuestionGCThirteenContent" class="collapse" aria-labelledby="QuestionGCThirteen" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka 裡面有內建的文法修正功能，會自動幫你抓出錯誤並修正，讓改寫後的文章更順暢、沒有語病。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCFouteen">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionGCFouteenContent" aria-expanded="true" aria-controls="QuestionGCFouteenContent">
                                        Trinka 改寫工具怎麼幫助學術作品更有原創性？
                                    </a>
                                </div>

                                <div id="QuestionGCFouteenContent" class="collapse" aria-labelledby="QuestionGCFouteen" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka 用創新的改寫技術，幫你激發靈感，讓改寫後的內容更有新意，提升作品的原創感。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCFivteen">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionGCFivteenContent" aria-expanded="true" aria-controls="QuestionGCFivteenContent">
                                        Trinka 改寫工具能保持改寫內容的一致性嗎？
                                    </a>
                                </div>

                                <div id="QuestionGCFivteenContent" class="collapse" aria-labelledby="QuestionGCFivteen" data-parent="#faq">
                                    <div class="card-body">
                                        <p>是的，Trinka 會確保改寫的內容前後一致、結構清楚，讓文章讀起來更順暢。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCSixteen">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionGCSixteenContent" aria-expanded="true" aria-controls="QuestionGCSixteenContent">
                                        Trinka 改寫工具怎麼幫你避免無意抄襲？
                                    </a>
                                </div>

                                <div id="QuestionGCSixteenContent" class="collapse" aria-labelledby="QuestionGCSixteen" data-parent="#faq">
                                    <div class="card-body">
                                        <p>
                                            Trinka 用先進的演算法，確保改寫的過程是嚴謹的，會檢查並防止無意間的抄襲。這能確保你的內容保持原創性，並避免任何意外的複製。
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCSeventeen">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionGCSeventeenContent" aria-expanded="true" aria-controls="QuestionGCSeventeenContent">
                                        Trinka 改寫工具有沒有瀏覽器擴充功能，讓使用更方便？
                                    </a>
                                </div>

                                <div id="QuestionGCSeventeenContent" class="collapse" aria-labelledby="QuestionGCSeventeen" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka 很快就會推出瀏覽器擴充功能，讓你寫作時能更快速、方便地使用改寫工具。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCEighteen">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionGCEighteenContent" aria-expanded="true" aria-controls="QuestionGCEighteenContent">
                                        Trinka 改寫工具會推出 Word 外掛程式版本嗎？
                                    </a>
                                </div>

                                <div id="QuestionGCEighteenContent" class="collapse" aria-labelledby="QuestionGCEighteen" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka 改寫工具即將推出 Word 外掛程式，讓您能在熟悉的寫作環境中輕鬆使用，快速存取並提升寫作效率。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCNinteen">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionGCNinteenContent" aria-expanded="true" aria-controls="QuestionGCNinteenContent">
                                        Trinka 改寫工具能跟其他寫作工具或平台一起用嗎？
                                    </a>
                                </div>

                                <div id="QuestionGCNinteenContent" class="collapse" aria-labelledby="QuestionGCNinteen" data-parent="#faq">
                                    <div class="card-body">
                                        <p>未來 Trinka 有機會跟市面上熱門的寫作工具或平台整合，讓你用起來更順手、更方便。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGC20">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionGC20Content" aria-expanded="true" aria-controls="QuestionGC20Content">
                                        若使用 Trinka 改寫工具時遇到問題，有提供客服支援嗎？
                                    </a>
                                </div>

                                <div id="QuestionGC20Content" class="collapse" aria-labelledby="QuestionGC20" data-parent="#faq">
                                    <div class="card-body">
                                        <p>
                                            Trinka 擁有專屬的客服團隊，隨時為您解決使用過程中遇到的各種問題。如有需要，請聯繫 <a href="mailto:support@trinka.ai">Trinka 客服團隊</a>。
                                           
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGC21">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionGC21Content" aria-expanded="true" aria-controls="QuestionGC21Content">
                                        Trinka 改寫工具怎麼保護用戶的資料和內容？
                                    </a>
                                </div>

                                <div id="QuestionGC21Content" class="collapse" aria-labelledby="QuestionGC21" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka 改寫工具遵循嚴格的資料隱私政策，確保用戶的資料和內容安全無虞。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGC22">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionGC22Content" aria-expanded="true" aria-controls="QuestionGC22Content">
                                        Trinka 改寫工具是否會定期進行更新和改進？
                                    </a>
                                </div>

                                <div id="QuestionGC22Content" class="collapse" aria-labelledby="QuestionGC22" data-parent="#faq">
                                    <div class="card-body">
                                        <p>
                                            Trinka 改寫工具持續優化中，團隊不斷進行更新與改進，致力提升效能與使用體驗，為用戶帶來更高效、更貼心的服務。
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGC23">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionGC23Content" aria-expanded="true" aria-controls="QuestionGC23Content">
                                        用戶的反饋和建議會被 Trinka 改寫工具納入改進嗎？
                                    </a>
                                </div>

                                <div id="QuestionGC23Content" class="collapse" aria-labelledby="QuestionGC23" data-parent="#faq">
                                    <div class="card-body">
                                        <p>
                                            當然會！用戶的意見對 Trinka 來說超重要，我們會認真聽取並納入開發，讓產品越做越好，更貼近大家的需求。
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
